import { render, staticRenderFns } from "./SelecionarDocumento.vue?vue&type=template&id=ae45c7c8&scoped=true&"
import script from "./SelecionarDocumento.vue?vue&type=script&lang=js&"
export * from "./SelecionarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarDocumento.vue?vue&type=style&index=0&id=ae45c7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae45c7c8",
  null
  
)

export default component.exports